import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ProgramFinanceMetricsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-program-finance-metrics',
  templateUrl: 'program-finance-metrics.html',
})
export class ProgramFinanceMetricsPage {

  definitions: any[] = [
    {
      field: "Physician ID",
      definition: "Physician ID from IMS"
    },
    {
      field: "Physician last Name",
      definition: "Last name of Physician from IMS"
    },
    {
      field: "Physician First Name",
      definition: "First Name of Physician from IMS"
    },
    {
      field: "Specialty",
      definition: "Physician Specialty from IMS"
    },
    {
      field: "Physician Province",
      definition: "Physician Province of practice"
    },
    {
      field: "Total Primary Patients",
      definition: "Total number of patients enrolled for corresponding Physician"
    },
    {
      field: "Active Patients",
      definition: "Total number of patients that are currently not in status \"Not Active"
    },
    {
      field: "Pending  Patients",
      definition: "Total number of patients that are currently in status Pending Enrolment, Pending Reimbursement or Pending Injection"
    },
    {
      field: "On Hold Patients",
      definition: "Total number of patients that are curretnly in status On Hold"
    },
    {
      field: "Suspension Patients",
      definition: "Total number of patients that are currently in status Suspension"
    },
    {
      field: "On Drug Patients",
      definition: "Total number of patients that are currently in status On Drug (Commercial, Bridging, SAP)"
    },
    {
      field: "Not Active Patients",
      definition: "Total number of patients that are currently in status Not Active"
    },
    {
      field: "Diagnosis - RIR DTC",
      definition: "Total Number of patients that have indicated a diagnosis of RIR DTC"
    },
    {
      field: "# Commercial Patients",
      definition: "Total number of patients that are commercial"
    },
    {
      field: "# of Compassionate Patients",
      definition: "Total number of patients that are compassionate"
    },
    {
      field: "# of Bridging Patients",
      definition: "Total number of patients that are bridging"
    },
    {
      field: "Public",
      definition: "Total number of patients who only have public insurance plans"
    },
    {
      field: "Priv+Public",
      definition: "Total number of patients who have public as well as private (self and/or spouse) insurance plans"
    },
    {
      field: "Private",
      definition: "Total number of patients who only have private (self and/or spouse) insurance plans"
    },
    {
      field: "Coverage Secured",
      definition: "Total number of patients who have at least one insurance plan that has been approved coverage"
    },
    {
      field: "Coverage Denied",
      definition: "Total number of patients who do not have approved insurance plan and at least one insurance plan that has denied coverage"
    },
    {
      field: "Last Enrolment Date",
      definition: "The date when the last patient was enrolled"
    },
    {
      field: "Enrolments Last Month",
      definition: "Total number of enrolments in the last completed month (i.e. if this report runs in March, it will provide the number of enrolments from February)"
    },
    {
      field: "Enrolments In Last 3 Months",
      definition: "Total number of enrolments in the last 3 completed months (i.e. if this report runs in March, it will provide the number of enrolments from February, January, and December)"
    },
    {
      field: "Enrolments In Last 6 Months",
      definition: "Total number of enrolments in the last 6 completed months"
    },
    {
      field: "Enrolments In Last 12 Months",
      definition: "Total number of enrolments in the last 12 completed months"
    },
    {
      field: "Time To Ready",
      definition: "Business days between Enrolment Complete Date and First Order Creation Date for first Drug Order. And Business Days between Next Order Date of previous order and Order Created Date of current Order for each subsequent order."
    },
    {
      field: "New/Repeat prescription",
      definition: "When prescription is New or Change, this field is set to New. When Prescription type is Repeat, this field is set to Repeat."
    },
    {
      field: "Order Creation Date",
      definition: "The date when the order was created in the application. This datestamp is automatically set by the application when an order is created."
    },
    {
      field: "Order Shipped Date (Warehouse ships to Pharmacy)",
      definition: "The date when the order was shipped to the pharmacy from warehouse."
    },
    {
      field: "Rx Dose (mg)",
      definition: "Prescription information from the last prescription entered in the application prior to the order created date."
    },
    {
      field: "Rx Frequency",
      definition: ""
    },
    {
      field: "Rx Repeats",
      definition: ""
    },
    {
      field: "Down Dosing",
      definition: "Y' is the dose on the prescription is less than the previous prescription. Otherwise 'N'."
    },
    {
      field: "Launch Week #",
      definition: "Week of April 4th is set to Launch Week. This field calculates the number of weeks from Launch week for the Order Creation Date. i.e. how many weeks away is the Order Creation date from the Launch Week."
    },
    {
      field: "Launch Month #",
      definition: "Month of April is set to Launch Month. This field calculates the number of months from Launch Month for the Order Creation Date. I.e. how many months away is the Order Creation Date from the Launch Month."
    },
    {
      field: "Patient Number",
      definition: "Patient File Number"
    },
    {
      field: "Gender",
      definition: "Patient Gender"
    },
    {
      field: "Weight (kg)",
      definition: "Baseline Weight"
    },
    {
      field: "Date of Birth",
      definition: "Patient Date of birth"
    },
    {
      field: "Patient Status",
      definition: "Patient's Current Program Status"
    },
    {
      field: "Patient Sub Status",
      definition: "Patient's Current Program Sub-status"
    },
    {
      field: "Enrolment Received Date",
      definition: "Date enrolment form was received"
    },
    {
      field: "Enrolment Completed Date",
      definition: "Date enrolment was completed with patient"
    },
    {
      field: "Welcome Call First Attempted Date",
      definition: "Date of First attempt to contact patient"
    },
    {
      field: "Reimbursement Complete Date",
      definition: "Date reimbursement was completed (i.e. any payer approved coverage OR all payers have denied coverage)."
    },
    {
      field: "First Order Submitted Date (Commercial or Compassionate)",
      definition: "This is the date when the first order was submitted, where the Order Type is \"Drug Commercial\" or \"Drug Compassionate"
    },
    {
      field: "First Commercial Order Date",
      definition: "This is the date when the first order was submitted, where the Order Type is \"Drug Commercial"
    },
    {
      field: "Therapy Start Date",
      definition: "This is the \"on drug start date\" as defined for each patient."
    },
    {
      field: "Days from Enrolment Complete to First Order Completed",
      definition: "This is the number of business days between the Enrolment Complete Date and the date when the first order went into \"Complete\" status."
    },
    {
      field: "Long",
      definition: "Not defined yet."
    },
    {
      field: "Starting Dose (mg)",
      definition: "Dosage from the first prescription"
    },
    {
      field: "Starting Frequency",
      definition: "Frequency from the first prescription"
    },
    {
      field: "Current Dose",
      definition: "Dosage from the most recent prescription"
    },
    {
      field: "Current Frequency",
      definition: "Frequency from the most recent prescription"
    },
    {
      field: "Diagnosis",
      definition: "Indication"
    },
    {
      field: "Diagnosis Date",
      definition: "Date of patient's diagnosis"
    },
    {
      field: "Current Therapies at Enrolment",
      definition: "Adriamycin (doxorubicin)"
    },
    {
      field: "",
      definition: "Sutent"
    },
    {
      field: "",
      definition: "Afinitor"
    },
    {
      field: "",
      definition: "Inylta"
    },
    {
      field: "",
      definition: "Caprelsa"
    },
    {
      field: "",
      definition: "Votrient"
    },
    {
      field: "",
      definition: "Cometriq"
    },
    {
      field: "",
      definition: "Nexavar"
    },
    {
      field: "Previous Therapies",
      definition: "Adriamycin (doxorubicin)"
    },
    {
      field: "",
      definition: "Sutent"
    },
    {
      field: "",
      definition: "Afinitor"
    },
    {
      field: "",
      definition: "Inylta"
    },
    {
      field: "",
      definition: "Caprelsa"
    },
    {
      field: "",
      definition: "Votrient"
    },
    {
      field: "",
      definition: "Cometriq"
    },
    {
      field: "",
      definition: "Nexavar"
    },
    {
      field: "Physician Last Name",
      definition: "MD Surname"
    },
    {
      field: "Physician First Name",
      definition: "MD Given Name"
    },
    {
      field: "Physician ID",
      definition: "IMS ID"
    },
    {
      field: "Physician Primary Specialty",
      definition: "MD's Specialty"
    },
    {
      field: "Physician City",
      definition: "MD's City (address)"
    },
    {
      field: "Physician Province",
      definition: "MD's Province (address)"
    },
    {
      field: "Physician Acct Name (site)",
      definition: "Hospital Name"
    },
    {
      field: "Physician Territory",
      definition: "MD's Territory (definition provided by Eisai)"
    },
    {
      field: "Physician Region",
      definition: "MD's Region (definition provided by Eisai)"
    },
    {
      field: "Physician Priority",
      definition: "MD's Priority (definition provided by Eisai)"
    },
    {
      field: "Current Pharmacy",
      definition: "Pharmacy Name"
    },
    {
      field: "Drug Type",
      definition: "Commercial/Compassionate/Undefined"
    },
    {
      field: "Reimbursement type",
      definition: "Private/Public"
    },
    {
      field: "Reimbursement Status",
      definition: "Active/Pending"
    },
    {
      field: "Private - Self",
      definition: "Name of Insurance provider"
    },
    {
      field: "Private - Self Outcome",
      definition: "Approved/Denied/Pending"
    },
    {
      field: "% Coverage",
      definition: "% of coverage (if approved)"
    },
    {
      field: "Copayment Max",
      definition: "Yes/No if plan has a Copayment Max"
    },
    {
      field: "Copayment Max Amount",
      definition: "Copayment Max amount if plan has a copayment max"
    },
    {
      field: "Deductible",
      definition: "Yes/No if plan has a Deductible"
    },
    {
      field: "Deductible Amount",
      definition: "Deductible amount if plan has a deductible"
    },
    {
      field: "Maximum amount",
      definition: "Coverage maximum amount (if plan has a coverage maximum)"
    },
    {
      field: "Maximum Period",
      definition: "Time period for coverage maximum (e.g. annual, lifetime)"
    },
    {
      field: "Private - Spouse",
      definition: "Name of Insurance provider"
    },
    {
      field: "Private - Spouse Outcome",
      definition: "Approved/Denied/Pending"
    },
    {
      field: "% Coverage",
      definition: "% of coverage (if approved)"
    },
    {
      field: "Copayment Max",
      definition: "Yes/No if plan has a Copayment Max"
    },
    {
      field: "Copayment Max Amount",
      definition: "Copayment Max amount if plan has a copayment max"
    },
    {
      field: "Deductible",
      definition: "Yes/No if plan has a Deductible"
    },
    {
      field: "Deductible Amount",
      definition: "Deductible amount if plan has a deductible"
    },
    {
      field: "Maximum Amount",
      definition: "Coverage maximum amount (if plan has a coverage maximum)"
    },
    {
      field: "Maximum Period",
      definition: "Time period for coverage maximum (e.g. annual, lifetime)"
    },
    {
      field: "Public",
      definition: "Name of Insurance provider"
    },
    {
      field: "Public Outcome",
      definition: "Approved/Denied/Pending"
    },
    {
      field: "% Coverage",
      definition: "% of coverage (if approved)"
    },
    {
      field: "Copayment Max",
      definition: "Yes/No if plan has a Copayment Max"
    },
    {
      field: "Copayment Max Amount",
      definition: "Copayment Max amount if plan has a copayment max"
    },
    {
      field: "Deductible",
      definition: "Yes/No if plan has a Deductible"
    },
    {
      field: "Deductible Amount",
      definition: "Deductible amount if plan has a deductible"
    },
    {
      field: "Maximum Amount",
      definition: "Coverage maximum amount (if plan has a coverage maximum)"
    },
    {
      field: "Maximum Period",
      definition: "Time period for coverage maximum (e.g. annual, lifetime)"
    }];

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProgramFinanceMetricsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/program-finance-metrics/program-finance-metrics.ts